import { useQuery, gql } from "@apollo/client";

export const SKILL_FRAGMENT = gql`
  fragment SkillFragment on Skill {
    id
    name
    kind
    locale
  }
`;

export const GET_SKILLS = gql`
  query getSkills(
    $q: String
    $locale: String
    $page: Int
  ) {
    skills(
      q: $q
      locale: $locale
      page: $page
    ) {
      collection {
        ...SkillFragment
      }
    }
  }
  ${SKILL_FRAGMENT}
`;

export default (options) => {
  return useQuery(GET_SKILLS, options);
};
